import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PageLinks from '../components/PageLinks';
import Brand from '../components/Brand';
import Footer from '../components/Footer';

class Pricing extends Component {
  
  componentDidMount() {
    window.analytics.page("View Pricing");
  }

  render() {
    return(
      <div class="public pricing">
        <header className="App-header">
          <Brand />
          <PageLinks />
          <ul className="account">
            <Link className="btn" to="/signup">Get Started</Link>
          </ul>
        </header>
        <div class="hero">
          <div class="content">
            <h1>Build Freely</h1>
            <h4>
            We're offering Pinstripe for free for the length of our beta. We'll be launching with a free tier and we'll make sure to notify you when paid options are available.
            </h4>
            <div className="card">
            <h4 className="subheading">Beta Program</h4>
            <h2>Free</h2>
            <hr/>
            <br/>
            <h3>Unlimited Projects</h3>
            <h3>Access to Customer Support</h3>
            <h3>48 hour response time</h3>
            <h3>No Credit Card Required</h3>
            <br/>
            <Link className="btn" to="/signup">Try It Free</Link>
          </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default Pricing;


// WEBPACK FOOTER //
// ./src/pages/Pricing.js